import { NextRouter } from 'next/router';
import { Routes } from 'services/routes';

export const buildSchoolLink = (slug: string, router: NextRouter): string => {
  if (typeof window !== 'undefined' && router) {
    const url = new URL(router.asPath, location.href);
    url.searchParams.delete('organization');

    return url.href;
  }

  return Routes.explore(slug);
};

export const buildOrganisationLink = (
  organisationId: string,
  schoolSlug: string,
  router: NextRouter,
): string => {
  if (typeof window !== 'undefined' && router) {
    const url = new URL(router.asPath, location.href);
    url.searchParams.set('organization', organisationId);
    return url.href;
  }

  const link = Routes.explore(schoolSlug) + '?organization=' + organisationId;

  return link;
};
